import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Clock, LogOut, RefreshCw } from 'lucide-react';

export default function PendingApprovalPage() {
  const { user, logout, refreshUser } = useAuth();
  const [checking, setChecking] = React.useState(false);

  const handleCheckStatus = async () => {
    setChecking(true);
    try {
      const updatedUser = await refreshUser();
      if (updatedUser?.approved) {
        window.location.href = '/';
      }
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-[#121212] border-[#27272A]">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 mx-auto mb-6 bg-[#FFD60A]/10 border border-[#FFD60A]/30 flex items-center justify-center">
            <Clock className="w-10 h-10 text-[#FFD60A]" />
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-2">
            Waiting for Approval
          </h1>
          
          <p className="text-[#71717A] mb-6">
            Your account is pending approval from the Head Coach or Trainer.
            You'll be able to access the system once approved.
          </p>

          <div className="bg-[#1A1A1A] border border-[#27272A] p-4 mb-6">
            <p className="text-xs text-[#71717A] uppercase tracking-wider mb-1">Signed in as</p>
            <p className="text-white font-medium">{user?.name}</p>
            <p className="text-[#71717A] text-sm">{user?.email}</p>
            <p className="text-[#FF3B30] text-xs mt-2 uppercase">
              {user?.role?.replace('_', ' ')}
            </p>
          </div>

          <div className="space-y-3">
            <Button
              onClick={handleCheckStatus}
              disabled={checking}
              className="w-full bg-[#FF3B30] hover:bg-[#FF3B30]/90 text-white"
              data-testid="check-status-btn"
            >
              <RefreshCw className={`w-4 h-4 mr-2 ${checking ? 'animate-spin' : ''}`} />
              {checking ? 'Checking...' : 'Check Approval Status'}
            </Button>
            
            <Button
              onClick={logout}
              variant="outline"
              className="w-full border-[#27272A] text-white hover:bg-[#1A1A1A]"
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Sign Out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
